import { Injectable } from '@angular/core';
import { GenericHttpService } from './generic-http.service';
import { of } from 'rxjs'; 
@Injectable({
  providedIn: 'root'
})
export class CatEditService {
  orderDetails: any;

  constructor(public httpService: GenericHttpService) { }



  getTemplate(param: any) {
    return this.httpService.Get('/order/cat/templates/' + param);
  }


  getCustomTemplateFields(data) {
    return this.httpService.Get(`/order/cat-template-field-customize/?account_id=${data.account_id}&template_id=${data.template_id}`);
  }

  postOrder(data: any) {
    return this.httpService.Post(data, '/order/cat/edit/upload/');
  }

  getUserDetails() {
    return this.httpService.Get('/user/get/account/details/');
  }

  getOrderConfirmation(data) {
    return this.httpService.Get('/order/orders/?order_ids=' + data.order_ids + '&detail=' + data.detail);
  }

  getOrValidateReferenceId(queryParams?) {
    if (queryParams) {
      return this.httpService.Get(
        '/order/orders-reference-id/?reference_id=' + queryParams
      );
    } else {
      return this.httpService.Get('/order/orders-reference-id/');
    }
  }

  sendExcelDocument(data) {
    return this.httpService.Post(data, '/bulk-order/store-file/');
  }

  getExcelDocument(id) {
    return this.httpService.Get(`/bulk-order/store-file/?bulk_order_id=${id}`)
  }


  uploadComposeFile(file: File, sessionId: string, accountId: string) {
    // const formData = new FormData();
    // formData.append('file', file, file.name);
    // formData.append('session_id', sessionId);
    // formData.append('account_id', accountId);
    // formData.append('file_type', file.type === 'application/pdf' ? 'pdf' : 'image');
    // return this.httpService.PostEncoded(formData, '/order/cat/compose/upload-file/', {});
      return of({ status: 200, content: {}, message: 'API temporarily disabled' });
  }
}
